import {
  Component,
  booleanAttribute,
  computed,
  inject,
  input,
  output
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SegmentsStateService } from 'src/app/core/services/segments-state.service';
import { DropdownOption } from 'src/app/shared/components/dropdown-select/dropdown-option.model';
import { DropdownSelectComponent } from 'src/app/shared/components/dropdown-select/dropdown-select.component';

import { GradeModel } from '../../../core/models/grade.model';
import { SegmentModel } from '../../../core/models/segment.model';

@Component({
  selector: 'liv-series-filter',
  imports: [DropdownSelectComponent],
  templateUrl: './series-filter.component.html',
  styleUrls: ['./series-filter.component.scss'],
  standalone: true
})
export class SeriesFilterComponent {
  readonly expanded = input(false, {
    transform: booleanAttribute
  });
  readonly layout = input<'standalone' | 'inline'>('standalone');

  selectSegment = output<SegmentModel>();
  selectGrade = output<GradeModel>();

  private segmentsStateService = inject(SegmentsStateService);

  segments = toSignal(this.segmentsStateService.segments$, {
    initialValue: [] as SegmentModel[]
  });
  selectedSegment = toSignal(this.segmentsStateService.selectedSegment$, {
    initialValue: null
  });
  selectedGrade = toSignal(this.segmentsStateService.selectedGrade$, {
    initialValue: null
  });

  segmentOptions = computed<DropdownOption[]>(() =>
    this.segments().map((segment) => ({
      value: segment.id,
      label: segment.nome
    }))
  );

  years = computed(() => {
    const segment = this.selectedSegment();
    if (!segment) {
      return [];
    }
    return segment.anos.map((ano) => ({
      ...ano,
      nome: this.formatGradeName(ano.nome)
    }));
  });

  formattedSegmentName = computed(() => {
    const segment = this.selectedSegment();
    if (!segment) {
      return '';
    }
    return this.formatSegmentName(segment.nome);
  });

  handleSelectSegment(segmentId: string | number): void {
    const segment = this.segments().find((item) => item.id === segmentId);

    if (!segment || this.selectedSegment()?.id === segment.id) {
      return;
    }

    this.segmentsStateService.selectSegment(segment.id);
    this.selectSegment.emit(segment);
  }

  handleSelectGrade(year: GradeModel): void {
    if (this.selectedGrade()?.id === year.id) {
      return;
    }
    this.segmentsStateService.selectGrade(year.id);
    this.selectGrade.emit(year);
  }

  private formatSegmentName(name: string): string {
    return name.includes('Fundamental')
      ? name.replace('Fundamental', 'Fund.')
      : name;
  }

  private formatGradeName(name: string): string {
    return name.includes('Infantil') ? name.replace('Infantil', '') : name;
  }
}
